import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Section from '../../../shared/Section/Section';
import { styles } from './styles';
import AlumniCompanies from '../../AlumniCompanies/AlumniCompanies';
import Statistic from '../../../shared/Statistic/Statistic';
import Research from '../../../shared/Research/Research';

function EmploymentStatistics({ title, subtitle, data }) {
  const isDownLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return (
    <>
      <Section
        anchor="employment"
        theme="light"
        title={title}
        subtitle={subtitle}
        wrapperStyles={styles.sectionWrapper}
      >
        <Box sx={{ my: 4 }}>
          <Statistic statistic={data.statistic} />
        </Box>
        <Box sx={{ my: { xs: 3, xl: 8 } }}>
          <Research {...data.research} />
        </Box>

        {!isDownLg && (
          <Box>
            <Typography
              variant="desktopH3"
              color={'kit.text.main'}
              sx={{ mt: { xs: 4, xl: 16 }, mb: 4 }}
            >
              Где работают наши выпускники
            </Typography>
            <AlumniCompanies />
          </Box>
        )}
      </Section>
      {isDownLg && (
        <Section>
          <Box>
            <Typography
              variant="desktopH3"
              color={'kit.text.main'}
              sx={{ mb: 3 }}
            >
              Где работают наши выпускники
            </Typography>
            <AlumniCompanies />
          </Box>
        </Section>
      )}
    </>
  );
}

export default EmploymentStatistics;
